import axios from './axios';

export default {
  createProjectRole: async body => {
    const { data } = await axios.post(`/composed-bys`, body);
    return data;
  },

  updateProjectRole: async (id, body) => {
    const { data } = await axios.put(`/composed-bys/${id}`, body);
    return data;
  },

  deleteProjectRole: async id => {
    const { data } = await axios.delete(`/composed-bys/${id}`);
    return data;
  }
};
